<template>
  <section>
    <el-table
      v-if="isLoading"
      v-loading="isLoading"
      :data="[]"
      element-loading-text="Загрузка..."
    />
    <div v-else>
      <div v-if="hasAnyInfo">
        <div v-if="hasResponsesInfo" class="statistics">
          <div class="statistics__title">
            <i class="el-icon-warning" />
            <span>Неутвержденные отклики</span>
          </div>
          <div v-if="totalInfo.today.responses.total" class="statistics__info">
            <div class="statistics__info-date">
              <div>Сегодня</div>
              <div>{{totalInfo.today.responses.total}}</div>
            </div>
            <div>
              <div class="statistics__info-link" @click="goToDay(totalInfo.today.responses.oldest, 'response')">
                ранний в
                {{ totalInfo.today.responses.oldest.created_at.slice(-5)}}
                &nbsp;(
                {{ totalInfo.today.responses.oldest.created_at.slice(0,5)}}
                )
              </div>
              <div class="statistics__info-types">
                <div>
                  <div>из приложения</div>
                  <div>ручных</div>
                </div>
                <div>
                  <div>{{ totalInfo.today.responses.manual}}</div>
                  <div>{{ totalInfo.today.responses.admin}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="totalInfo.tomorrow.responses.total" class="statistics__info">
            <div class="statistics__info-date">
              <div>Завтра</div>
              <div>{{totalInfo.tomorrow.responses.total}}</div>
            </div>
            <div>
              <div class="statistics__info-link" @click="goToDay(totalInfo.tomorrow.responses.oldest, 'response')">
                ранний в
                {{ totalInfo.tomorrow.responses.oldest.created_at.slice(-5)}}
                &nbsp;(
                {{ totalInfo.tomorrow.responses.oldest.created_at.slice(0,5)}}
                )
              </div>
              <div class="statistics__info-types">
                <div>
                  <div>из приложения</div>
                  <div>ручных</div>
                </div>
                <div>
                  <div>{{ totalInfo.tomorrow.responses.manual}}</div>
                  <div>{{ totalInfo.tomorrow.responses.admin}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasRequestsInfo" class="statistics">
          <div class="statistics__title">
            <i class="el-icon-warning" />
            <span>Необработанные заявки на отклик</span>
          </div>
          <div v-if="totalInfo.today.requests.total" class="statistics__info">
            <div class="statistics__info-date">
              <div>Сегодня</div>
              <div>{{totalInfo.today.requests.total}}</div>
            </div>
            <div>
              <div class="statistics__info-link" @click="goToDay(totalInfo.today.requests.oldest, 'request')">
                ранний в
                {{ totalInfo.today.requests.oldest.created_at.slice(-5)}}
                &nbsp;(
                {{ totalInfo.today.requests.oldest.created_at.slice(0,5)}}
                )
              </div>
            </div>
          </div>
          <div v-if="totalInfo.tomorrow.requests.total" class="statistics__info">
            <div class="statistics__info-date">
              <div>Завтра</div>
              <div>{{totalInfo.tomorrow.requests.total}}</div>
            </div>
            <div>
              <div class="statistics__info-link" @click="goToDay(totalInfo.tomorrow.requests.oldest, 'request')">
                ранний в
                {{ totalInfo.tomorrow.requests.oldest.created_at.slice(-5)}}
                &nbsp;(
                {{ totalInfo.tomorrow.requests.oldest.created_at.slice(0,5)}}
                )
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-info">
        Нет необработанных <br>
        заявок и откликов
      </div>
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapMutations } from 'vuex'
const StatisticApi = RepositoryFactory.get('statistic')

export default {
  name: 'StatisticByResponses',
  data() {
    return {
      totalInfo: {
        today: {
          requests: {
            total: 0,
          },
          responses: {
            total: 0,
          },
        },
        tomorrow: {
          requests: {
            total: 0,
          },
          responses: {
            total: 0,
          },
        },
      },
      isLoading: true
    }
  },
  computed: {
    hasResponsesInfo() {
      return (
        this.totalInfo.today.responses.total ||
        this.totalInfo.tomorrow.responses.total
      )
    },
    hasRequestsInfo() {
      return (
        this.totalInfo.today.requests.total ||
        this.totalInfo.tomorrow.requests.total
      )
    },
    hasAnyInfo() {
      return this.hasResponsesInfo || this.hasRequestsInfo
    },
  },
  async created() {
    const { data } = await StatisticApi.getResponsesStatistic()
    this.totalInfo = data
    this.isLoading = false
  },
  methods: {
    ...mapMutations({
      setHighlightResponseId: 'loadDay/setHighlightResponseId',
      setHighlightRequestId: 'loadDay/setHighlightRequestId',
    }),
    goToDay(bidDay, type) {
      if (type === 'response') {
        this.setHighlightResponseId(bidDay.response_id)
      } else {
        this.setHighlightRequestId(bidDay.request_id)
      }
      this.$router.push(`/bid/${bidDay.bid_id}/load-day/${bidDay.load_day_id}`)
    },
  },
}
</script>

<style lang="sass" scoped>
.statistics
  margin-bottom: 20px
  font-size: 14px

  &__title
    display: flex
    align-items: center
    margin-bottom: 10px
    font-size: 16px
    font-weight: bold
    i
      margin-right: 10px
      font-size: 20px
      color: #F10000

  &__info
    display: flex
    margin-bottom: 10px
    &-date
      display: flex
      justify-content: space-between
      width: 40%
      margin-right: 15px
    &-link
      color: #409EFF
      border-bottom: 1px solid
      cursor: pointer
      &:hover
        color: #3498db
    &-types
      display: flex
      justify-content: space-between

.no-info
  padding: 16px
  text-align: center
  border: 2px solid #5daf34
  border-radius: 8px
</style>
